import { Router } from '@angular/router'

let eventoDeRota

export default class RouterUtils {
    router: Router

    constructor(router: Router) {
        this.router = router
    }

    iniciarEventoDeRouter() {
        eventoDeRota = document.addEventListener(
            'ce-alt-econt-menu-navegar',
            (event) => this._navegarPorEvento(event),
            false
        )
    }

    private _navegarPorEvento(event) {
        if (event.detail) {
            const endereco = '/' + event.detail.endereco
            this._carregarNovaRota(endereco)
        }
    }

    private _carregarNovaRota(endereco) {
        if (!this.router.url.startsWith(endereco)) {
            this.router.navigateByUrl(endereco)
        }
    }

    removerEventoDeRouter() {
        document.removeEventListener('ce-alt-econt-menu-navegar', eventoDeRota)
    }
}



// WEBPACK FOOTER //
// ./src/app/menu/router.utils.ts